var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanama(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5819_33136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#FCCC4E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5819_33136)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 3,
    width: 9,
    height: 9,
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 9,
    height: 9,
    fill: "#005293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.25L8.03115 6.96885H9.75L8.35942 8.03115L8.89058 9.75L7.5 8.68769L6.10942 9.75L6.64058 8.03115L5.25 6.96885H6.96885L7.5 5.25Z",
    fill: "#005293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.25L17.0312 15.9688H18.75L17.3594 17.0312L17.8906 18.75L16.5 17.6877L15.1094 18.75L15.6406 17.0312L14.25 15.9688H15.9688L16.5 14.25Z",
    fill: "#D21034"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanama);
export default __webpack_public_path__ + "static/media/Panama.57dc48f6194e26132b5267de75afbeec.svg";
export { ForwardRef as ReactComponent };